module.exports = __webpack_public_path__ + "img/gpic4.png";